import React from "react";
import {Route} from "react-router-dom";
import UserService from "../../services/UserService";
import RedirectService from "../../services/RedirectService";

const clearSession = (props) => {
  if (!props.location.pathname.startsWith('/track/') && props.location.pathname !== '/list/all-assets') {
    sessionStorage.clear()
  }
}

const PrivateRoute = ({component, path, exact, isPrivate, currentUser, ...rest}) => {
  clearSession(rest)
  return (<Route path={path} exact={exact}
                 render={props => (
                   UserService.currentUser || isPrivate === false ? (React.createElement(component, {
                       ...props, ...rest, currentUser, ...rest
                     }))
                     : RedirectService.goToAuth()
                 )
                 }
  />);
};
export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/component/Routes/PrivateRoute.js